import React, { useState, useEffect } from 'react';
import { handleChange, handleSubmit } from "../../Controller/CreateAssetController";
import SupplierService from "../../../Supplier/Controller/SupplierController";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import AssetCategoryService from "../../../Setup/controller/AssetCategoryController/AssetCategoryController";
import AssetSubCategoryService from "../../../Setup/controller/AssetSubCategoryController/AssetSubCategoryController";
import AssetService from "../../Controller/AssetController";
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
import { quillModules, quillFormats, addToolbarTitles } from "../../../Common/quillConfig";
import SunTextEditor from "../../../Common/SunTextEditor";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import { PDFDocument } from "pdf-lib";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import Swal from 'sweetalert2';
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
function CustomerDetail({ AssetID, onSuccess, ClientCompanyID, isLock, onClose,writeOff }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [formData, setFormData] = useState({
        PK_Assets_ID: "0",
        PK_AssetHistory: "0",
        type: '0',
        dt_LastPurchaseDate: getCurrentDate(),
        FK_ClientCompanySupplier_ID: "0",
        FK_AssetCategoryID: "0",
        CustomerID: 0,
        vc_AssetCode: '',
        vc_AssetName: '',
        vc_SerialNumber: '',
        mon_SalesPrice: "0.00",
        vc_Location: "",
        vc_Manufacturer: "",
        vc_Description: "",
        vc_ManufacturerCode: "",
        vc_Condition: "",
        vc_Specification: "",
        FK_AssetSubCategory_ID: "0",
        snt_AssetCat: "0",
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0
    });

    const [SupplierList, setSupplier] = useState([]);
    const [CustomerList, setCustomer] = useState([]);
    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [AssetCategoryList, setAssetCategory] = useState([]);
    const [AssetSubCategoryList, setAssetSubCategory] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [selectedSite, setSelectedSite] = useState(null);
    const [KeyNameList, setKeyNames] = useState([]);
    const [showAssetExistMessage, setshowAssetExistMessage] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, AssetID, "3");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };
    const handleFieldChange = (event, keyItem = null) => {
        const { name, value } = event.target;
        setIsChanged(true);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };

    const resetForm = () => {

        setFormData({
            PK_Assets_ID: "0",
            PK_AssetHistory: "0",
            type: '0',
            dt_LastPurchaseDate: getCurrentDate(),
            FK_ClientCompanySupplier_ID: "0",
            FK_AssetCategoryID: "0",
            CustomerID: 0,
            vc_AssetCode: '',
            vc_AssetName: '',
            vc_SerialNumber: '',
            mon_SalesPrice: "0.00",
            vc_Location: "",
            vc_Manufacturer: "",
            vc_Description: "",
            vc_ManufacturerCode: "",
            vc_Condition: "",
            vc_Specification: "",
            FK_AssetSubCategory_ID: "0",
            snt_AssetCat: "0",
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0

        });
    };

    useEffect(() => {
        const initialize = async () => {
            await fetchSuppliers();
            await fetchCustomers();
            await fetchAssetCategory();
            await fetchAssetSubCategory();

            if (AssetID > 0) {
                await fetchAssetDetail();   // load core asset data first
                await fetchKeyNames();      // now load user-defined fields
            } else {
                resetForm();
                if (ClientCompanyID > 0) {
                    handleCustomerSelect(ClientCompanyID);
                }
                await fetchKeyNames();
            }
        };

        initialize();
    }, [AssetID]);

    // New useEffect to handle customer selection when type is updated to "1"
    useEffect(() => {
        if (ClientCompanyID > 0 && AssetID < 1) {
            handleCustomerSelect(ClientCompanyID);
            fetchKeyNames();
        }
    }, [ClientCompanyID, AssetID]);

    const fetchSuppliers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listofSuppliers = await SupplierService.GetAllSuppliers(redirectCallback);
            setSupplier(listofSuppliers);
        } catch (error) {
            console.error('Error fetching suppliers:', error);
        }
    };

    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };

    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            const headOfficeSite = listOfCustomerSites.filter(site => site.HeadOffice === 1);
            if (headOfficeSite.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite[0].ClientBranchID,
                }));
                await fetchCustomerContact(headOfficeSite[0].ClientBranchID);
            } else if (listOfCustomerSites.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: listOfCustomerSites[0].ClientBranchID,
                }));
                await fetchCustomerContact(listOfCustomerSites[0].ClientBranchID);
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };

    const fetchAssetCategory = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfAssetCategories = await AssetCategoryService.GetAllAssetCategories(redirectCallback);
            setAssetCategory(listOfAssetCategories);
        } catch (error) {
            console.error('Error fetching asset categories:', error);
        }
    };

    const fetchAssetSubCategory = async (categoryID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfSubCategory = await AssetSubCategoryService.GetSubCategoryByAssetID(redirectCallback, categoryID);
            setAssetSubCategory(listOfSubCategory);

            /* if (listOfSubCategory.length > 0) {
                 setFormData({
                     ...formData,
                     FK_AssetCategoryID: categoryID,
                     FK_AssetSubCategory_ID: listOfSubCategory[0].ID.toString()
                 });
             }*/
        } catch (error) {
            console.error('Error fetching asset subcategories:', error);
        }
    };

    const stripHtmlTags = (htmlString) => {
        const doc = new DOMParser().parseFromString(htmlString, "text/html");
        return doc.body.textContent || "";
    };
    const fetchAssetDetail = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            if (AssetID > 0) {

                const AssetDetail = await AssetService.GetAssetByID(redirectCallback, AssetID);
                console.log(AssetDetail[0]);

                const asset = AssetDetail[0];

                const formattedDate = new Date(asset.dt_LastPurchaseDate).toISOString().split('T')[0];
                setFormData(prev => ({
                    ...prev,
                    ...asset,
                    type: asset.type.toString(),
                    vc_Specification: asset.vc_Specification,
                    FK_AssetSubCategory_ID: asset.FK_AssetSubCategory_ID,
                    dt_LastPurchaseDate: formattedDate
                }));
               
                fetchAssetSubCategory(asset.FK_AssetCategoryID);
                if (asset.type.toString() === '1') {
                    populateCustomerSiteContactAccount(asset);
                }
            }
        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };

    const populateCustomerSiteContactAccount = async (asset) => {

        const customerId = asset.ClientCompanyID;
        const selectedCustomer = CustomerList.find(customer => customer.ClientCompanyID === parseInt(customerId));
        const formattedDate = new Date(asset.dt_LastPurchaseDate).toISOString().split('T')[0];
        await fetchCustomersSites(customerId);
        setFormData(prev => ({
            ...prev,
            ...asset,
            type: asset.type.toString(),
            CustomerID: customerId,
            AccountRef: asset.AccountRef,
            FK_ClientBranch_ID: asset.FK_ClientBranch_ID,
            FK_ClientContact_ID: asset.FK_ClientContact_ID,
            dt_LastPurchaseDate: formattedDate,
        }));


    };

    const handleRadioChange = (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            type: value
        });
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        const redirectCallback = () => {
            navigate('/');
        };

        const redirectUserList = () => {
            navigate('/AssetList?saved=true');
        };
        const IsAssetExist = await AssetService.IsAssetCodeExist(formData.PK_Assets_ID, formData.vc_AssetCode);
        debugger;
        if (formData.PK_Assets_ID=="0" && IsAssetExist.length > 0) {
            setshowAssetExistMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setshowAssetExistMessage(false);
            }, 5000);
            return false;
        }
        const message = await handleSubmit(event, formData, setFormData, setErrors, redirectCallback, redirectUserList);
        if (message == "Data saved successfully") {
            setIsChanged(false);
            onSuccess();
            AssetID = localStorage.getItem('AssetID');
            localStorage.setItem('HasRecordUpdated', "1");
            await handleUserDefineSubmit({
                JobID: localStorage.getItem('AssetID'),
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            await fetchAssetDetail();

            fetchKeyNames();
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            //  redirectUserList();
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
    };

    const handleCustomerChange = (event) => {
        const { value } = event.target;
        const customerId = event.target.value;
        const selectedCustomer = CustomerList.find(customer => customer.ClientCompanyID === parseInt(customerId));
        setFormData({
            ...formData,
            CustomerID: value,
            AccountRef: selectedCustomer ? selectedCustomer.AccountRef : '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0
        });

        fetchCustomersSites(value);
    };
    const handleCustomerSelect = async (CustomerID) => {
        const redirectCallback = () => {
            navigate('/');
        };

        try {
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            const selectedCustomer = listOfCustomers.find(customer => customer.ClientCompanyID === parseInt(CustomerID));
            debugger;
            if (selectedCustomer) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    type: "1",
                    ClientCompanyID: CustomerID,
                    AccountRef: selectedCustomer.AccountRef || '',
                    // FK_ClientBranch_ID: 0,
                    // FK_ClientContact_ID: 0
                }));

                await fetchCustomersSites(CustomerID);
            }
        } catch (error) {
            console.error("Error selecting customer:", error);
        }
    };
    const handleBranchChange = async (event) => {
        const { value } = event.target;
        const branchID = event.target.value;
        setFormData({
            ...formData,
            FK_ClientBranch_ID: value,
            FK_ClientContact_ID: 0
        });
        await fetchCustomerContact(value);

    };

    const handleCategoryChange = (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            FK_AssetCategoryID: value,
            //  FK_AssetSubCategoryID: 0
        });
        fetchAssetSubCategory(value);
    };

    const handleEditorChange = (content) => {
        setIsChanged(true);
        setFormData({
            ...formData,
            vc_Specification: content
        });
    };



    const HelpLink = localStorage.getItem('HelpLink');

    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }

                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);

    const generatePDF = async (event) => {
        event.stopPropagation();

        try {


            const blob = await getMergedPDFBlob({
                moduleId: "3",
                navigate,
                currentInputValues: {
                    ID: AssetID
                },
                defaultReportID: 115,
                setReportLink,
                setReportTitle,
                setError
            });

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);



        } catch (err) {
            console.error(err);
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            {showAssetExistMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Duplicate entry: An asset with the same code already exists.

                </div>
            )}
            <form onSubmit={handleFormSubmit} style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 335px)",     // IE/Edge
            }}>
                <div
                    style={{
                        //   flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        //  scrollbarWidth: "none", // Firefox
                        //  msOverflowStyle: "none", // IE/Edge
                    }}
                // className="scrollable-form"
                >
                    <table style={{ width: "100%" }}>
                        <tbody>

                            <tr>
                                <td style={{ width: "14%" }}><label htmlFor="Type" style={{ float: "right" }}>Select Type &nbsp;&nbsp;</label></td>

                                <td style={{ width: "36%" }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input style={{ position: "relative" }} className="form-check-input" type="radio" name="type" value="0" checked={formData.type === '0'} disabled={writeOff.toString() === '1'}
                                                    onChange={handleRadioChange}
                                                />
                                            </td>
                                            <td>
                                                <label className="col-form-label">Internal</label>
                                            </td>
                                            <td>
                                                <input style={{ position: "relative" }} className="form-check-input" type="radio" name="type" value="1" checked={formData.type === '1'} disabled={writeOff.toString() === '1'}
                                                    onChange={handleRadioChange}
                                                />
                                            </td>
                                            <td>
                                                <label className="col-form-label">External/Customer</label>
                                            </td>
                                        </tr>
                                    </table>
                                </td>

                                <td style={{ width: "14%" }}>


                                </td>
                                <td style={{ width: "36%" }}>

                                </td>
                            </tr>
                            {formData.type === '1' && (
                                <>
                                    <tr>
                                        <td><label htmlFor="CustomerID" style={{ float: "right" }}>Select Customer &nbsp;&nbsp;</label></td>
                                        <td>
                                            <select name="ClientCompanyID" className='form-control' value={formData.ClientCompanyID} onChange={handleCustomerChange} disabled={writeOff.toString() === '1'}>
                                                <option value="0">Select Customer</option>
                                                {CustomerList.map((customer) => (
                                                    <option key={customer.ClientCompanyID} value={customer.ClientCompanyID}>
                                                        {customer.CompanyName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.CustomerID && <div style={{ color: 'red' }}>{errors.CustomerID}</div>}
                                        </td>

                                        <td><label htmlFor="vc_SerialNumber" style={{ float: "right" }}> Site &nbsp;&nbsp;</label></td>
                                        <td>
                                            <select name="FK_ClientBranch_ID" className='form-control' value={formData.FK_ClientBranch_ID} onChange={handleBranchChange} disabled={writeOff.toString() === '1'}>
                                                <option value="0">Select Site</option>
                                                {CustomerSiteList.map((site) => (
                                                    <option key={site.ClientBranchID} value={site.ClientBranchID}>
                                                        {site.BranchName}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}>Contact &nbsp;&nbsp;</label></td>
                                        <td>
                                            <select name="FK_ClientContact_ID" className='form-control' value={formData.FK_ClientContact_ID} onChange={handleFieldChange} disabled={writeOff.toString() === '1'}>
                                                <option value="0">Select Contact</option>
                                                {CustomerContactList.map((contact) => (
                                                    <option key={contact.ClientContactID} value={contact.ClientContactID}>
                                                        {contact.Title} {contact.FirstName} {contact.SurName}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>

                                        <td><label htmlFor="vc_SerialNumber" style={{ float: "right" }}> Account No &nbsp;&nbsp;</label></td>
                                        <td>
                                            <input type="text" className="form-control" name="AccountRef" value={formData.AccountRef} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                        </td>
                                    </tr>
                                </>
                            )}
                            <tr>
                                <td><label htmlFor="vc_AssetCode" style={{ float: "right" }}>Asset Code <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="hidden" name="PK_Assets_ID" value={formData.PK_Assets_ID} onChange={handleFieldChange} />
                                    <input type="hidden" name="PK_AssetHistory" value={formData.PK_AssetHistory} onChange={handleFieldChange} />

                                    <input type="text" className="form-control" name="vc_AssetCode" value={formData.vc_AssetCode} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                    {errors.vc_AssetCode && <div style={{ color: 'red' }}>{errors.vc_AssetCode}</div>}
                                </td>
                                <td><label htmlFor="vc_AssetName" style={{ float: "right" }}>Asset Name <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_AssetName" value={formData.vc_AssetName} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                    {errors.vc_AssetName && <div style={{ color: 'red' }}>{errors.vc_AssetName}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Serial No. &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_SerialNumber" value={formData.vc_SerialNumber} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                    {errors.vc_SerialNumber && <div style={{ color: 'red' }}>{errors.vc_SerialNumber}</div>}
                                </td>
                                <td><label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Select Supplier &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="FK_ClientCompanySupplier_ID" className='form-control' value={formData.FK_ClientCompanySupplier_ID} onChange={handleFieldChange} disabled={writeOff.toString() === '1'}>
                                        <option value="0">Select Supplier</option>
                                        {SupplierList.map((supplier) => (
                                            <option key={supplier.PK_Supplier_ID} value={supplier.PK_Supplier_ID}>
                                                {supplier.vc_SupplierName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_ClientCompanySupplier_ID && <div style={{ color: 'red' }}>{errors.FK_ClientCompanySupplier_ID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="dt_LastPurchaseDate" style={{ float: "right" }}>Acquisition Date &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="date" className="form-control" name="dt_LastPurchaseDate" value={formData.dt_LastPurchaseDate} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                    {errors.dt_LastPurchaseDate && <div style={{ color: 'red' }}>{errors.dt_LastPurchaseDate}</div>}
                                </td>
                                <td><label htmlFor="mon_SalesPrice" style={{ float: "right" }}>Selling Price &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="mon_SalesPrice" value={formData.mon_SalesPrice} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                    {errors.mon_SalesPrice && <div style={{ color: 'red' }}>{errors.mon_SalesPrice}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Location" style={{ float: "right" }}>Location &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Location" value={formData.vc_Location} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                </td>
                                <td><label htmlFor="vc_Manufacturer" style={{ float: "right" }}>Source &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Manufacturer" value={formData.vc_Manufacturer} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Description" style={{ float: "right" }}>Brief Description &nbsp;&nbsp;</label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_Description" value={formData.vc_Description} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                </td>

                            </tr>
                            <tr>
                                <td><label htmlFor="vc_ManufacturerCode" style={{ float: "right" }}>Source Code &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_ManufacturerCode" value={formData.vc_ManufacturerCode} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />

                                </td>
                                <td><label htmlFor="FK_AssetCategoryID" style={{ float: "right" }}>Category &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="FK_AssetCategoryID" className='form-control' value={formData.FK_AssetCategoryID} onChange={handleCategoryChange} disabled={writeOff.toString() === '1'}>
                                        <option value="0">Select Category</option>
                                        {AssetCategoryList.map((category) => (
                                            <option key={category.ID} value={category.ID}>
                                                {category.AssetCategory}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_AssetCategoryID && <div style={{ color: 'red' }}>{errors.FK_AssetCategoryID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="FK_AssetSubCategory_ID" style={{ float: "right" }}>Sub Category &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="FK_AssetSubCategory_ID" className='form-control' value={formData.FK_AssetSubCategory_ID} onChange={handleFieldChange} disabled={writeOff.toString() === '1'}>
                                        <option value="0">Select Sub Category</option>
                                        {AssetSubCategoryList.map((subCategory) => (
                                            <option key={subCategory.ID} value={subCategory.ID}>
                                                {subCategory.SubCategoryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_AssetSubCategory_ID && <div style={{ color: 'red' }}>{errors.FK_AssetSubCategory_ID}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Condition" style={{ float: "right" }}>Condition &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Condition" value={formData.vc_Condition} onChange={handleFieldChange} disabled={writeOff.toString() === '1'} />
                                    {errors.vc_Condition && <div style={{ color: 'red' }}>{errors.vc_Condition}</div>}
                                </td>

                            </tr>

                            <tr>
                                <td><label htmlFor="vc_Specification" style={{ float: "right" }}>Specification &nbsp;&nbsp;</label></td>
                                <td colSpan={3}>
                                    <SunTextEditor
                                        value={formData.vc_Specification}
                                        onChange={(content) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                vc_Specification: content,
                                            }))
                                        }
                                    />
                                    {errors.vc_Specification && <div style={{ color: 'red' }}>{errors.vc_Specification}</div>}

                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-sm-6">

                    </div>
                    <div className="col-sm-6" style={{ "marginLeft": "0px", "float": "right", textAlign: "right" }}>
                        <button style={{ "marginLeft": "5px" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button style={{ float: "right", "marginLeft": "5px" }} type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0 || writeOff.toString() === '1'}  >
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {AssetID > 0 ? ' Update' : ' Save'}

                        </button>


                    </div>
                </div>

            </form>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
        </div>


    );
}
export default CustomerDetail;

